import { render, staticRenderFns } from "./CourseManagement.vue?vue&type=template&id=4c166ac6&scoped=true&"
import script from "./course-management.js?vue&type=script&lang=js&"
export * from "./course-management.js?vue&type=script&lang=js&"
import style0 from "./CourseManagement.vue?vue&type=style&index=0&id=4c166ac6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c166ac6",
  null
  
)

export default component.exports